import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { updateProjectDescription } from '@/features/projects/project-details/api/update-project-description';
import { useToast } from '@/shared/hooks/use-toast';

export const useUpdateProjectDescription = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('project', { keyPrefix: 'Shared' });

  return useMutation({
    mutationFn: updateProjectDescription,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects'] });
      toast({ title: t('project_description_saved') });
    },
    onError: () => {
      toast({
        title: t('project_description_error'),
        variant: 'destructive',
      });
    },
  });
};
